// extracted by mini-css-extract-plugin
export default {"image":"W3-z","loaded":"X3-z"};